import { render, staticRenderFns } from "./CreateContactBlock.vue?vue&type=template&id=b8cb44d6&scoped=true"
import script from "./CreateContactBlock.vue?vue&type=script&lang=js"
export * from "./CreateContactBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cb44d6",
  null
  
)

export default component.exports